import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-37">
          <div className="col-span-1 md:col-span-1" data-id="element-38">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-39">
              <span className="font-signature text-2xl text-coral" data-id="element-40">HelgiG</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-41">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-42">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-43">
              {t('footer.explore')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-44">
              <li data-id="element-45">
                <Link to="/" className="hover:text-coral transition-colors" data-id="element-46">
                  {t('footer.home')}
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/about" className="hover:text-coral transition-colors" data-id="element-48">
                  {t('footer.about')}
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-50">
                  {t('footer.services')}
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/contact" className="hover:text-coral transition-colors" data-id="element-52">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-53">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-54">
              {t('footer.servicesTitle')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-55">
              <li data-id="element-56">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-57">
                  {t('footer.firstTimeManager')}
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-59">
                  {t('footer.healthyConflicts')}
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-61">
                  {t('footer.artOfFacilitation')}
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-63">
                  {t('footer.agileLeadership')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-64">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-65">
              {t('footer.connectTitle')}
            </h4>
            <div className="flex space-x-4" data-id="element-66">
              <a href="#" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-coral hover:text-white transition-colors" data-id="element-67">
                <Instagram size={20} data-id="element-68" />
              </a>
              <a href="#" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-teal hover:text-white transition-colors" data-id="element-69">
                <Linkedin size={20} data-id="element-70" />
              </a>
              <a href="#" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-coral hover:text-white transition-colors" data-id="element-71">
                <Twitter size={20} data-id="element-72" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-73">
          <p data-id="element-74">
            &copy; {new Date().getFullYear()} HelgiG. {t('footer.copyright')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-75">
            <a href="#" className="hover:text-gray-600" data-id="element-76">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-77">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}